import { RejoinModal } from '../../session/rejoin/RejoinModal';
import { useProviderRejoinModalViewModel } from './useProviderRejoinModalViewModel';

export function ProviderRejoinModalWrapper() {
  const props = useProviderRejoinModalViewModel();

  return <RejoinModal {...props} />;
}
